export const ROW_STYLE_FULL_WIDTH = 'full_width'
export const ROW_STYLE_NORMAL = 'normal'
export const ROW_STYLE_SMALL_WIDE = 'small_wide'
export const ROW_STYLE_NORMAL_WIDE = 'normal_wide'
export const ROW_STYLE_LARGE_WIDE = 'large_wide'
export const ROW_STYLE_LARGE = 'large'
